import type { ImageParams } from 'components/Common/ResponsiveImage'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'

export const searchMapCardImageParams: ImageParams = {
  mobileAspectRatio: '17:6',
  mobileWidth: '100vw',
  tabletAspectRatio: '3:2',
  tabletWidth: '300px',
  fit: 'center',
}

export const SearchMapCardRoot = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: ${rem(140)} 1fr;
  height: 100%;

  ${mediaQueryUp.tablet} {
    background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
    border-radius: ${rem(16)};
    box-shadow: ${props => props.theme.shadow.flat.large};
    overflow: hidden;
    width: ${rem(300)};
    height: auto;
  }
`

export const SearchMapCardImageContainer = styled.div`
  position: relative;
`
